/** Berkas submissions, verification, and official documents. */

import { createDoc, updateDoc, setDocData } from '../service';
import { COL } from '../../collections';
import { utcNowIso } from '../../format';
import type { BeritaAcaraDoc, SkripsiDoc, SubmissionDoc } from '../../types';

/** Register an uploaded berkas (submission). url is a data-URI or storage URL. */
export async function addSubmission(data: {
  skripsiId: string;
  stage: SkripsiDoc['stage'];
  docType: SubmissionDoc['docType'];
  label: string;
  name: string;
  url: string;
  uploadedBy: string;
}) {
  return createDoc<SubmissionDoc>(COL.submissions, {
    ...data,
    kind: 'berkas',
    version: 1,
    status: 'submitted',
  });
}

export async function verifySubmission(
  id: string,
  status: 'verified' | 'rejected',
  verifiedBy: string,
  note?: string,
) {
  return updateDoc<SubmissionDoc>(COL.submissions, id, {
    status,
    verifiedBy,
    verifiedAt: utcNowIso(),
    note,
  });
}

/** Create an official document / berita acara record (number entered by staf). */
export async function createBeritaAcara(data: {
  type: BeritaAcaraDoc['type'];
  skripsiId: string;
  eventId?: string;
  nomor: string;
  tanggal?: string;
  judul: string;
  isi?: Record<string, any>;
  fileUrl?: string;
  issuedBy: string;
}) {
  return createDoc<BeritaAcaraDoc>(COL.beritaAcara, {
    ...data,
    tanggal: data.tanggal ?? utcNowIso(),
  });
}

export async function setDocDataAny<T extends object = any>(
  collectionName: (typeof COL)[keyof typeof COL],
  id: string,
  data: Partial<T>,
) {
  return setDocData<T & Record<string, any>>(collectionName, id, data, { merge: true });
}
